<template>
  <div class="dropdown-main-container">
    <p class="text">{{ title }}</p>
    <input
      v-model="data"
      class="text-input"
      :style="[
        isPrice && {
          height: '100px',
          fontSize: '25px',
        },
      ]"
      type="text"
      :id="inputId"
      :placeholder="placeholder"
      :inputmode="isPrice ? 'numeric' : 'text'"
      @focus="onFocusElement"
      @blur="onBlurElement"
      @input="filterInput"
      @keyup.enter="handleEnterKey"
    />
    <wallet-icon v-if="isPrice" class="dropdown-left-icon-price" />
    <key-icon v-else-if="isCategoryName" class="dropdown-left-icon-category" />
    <wallet-icon v-else class="dropdown-left-icon" />
    <div class="currency-container">
      <div v-if="isPrice" class="price-list-block" @click.stop="setIsOpenList">
        <p class="dropdown-list-checked-value">{{ checkedValue }}</p>
        <chevron-down-icon
          class="dropdown-chevron-icon"
          :style="[
            isOpenList && { transform: 'translateY(-50%) rotate(180deg)' },
          ]"
        />
      </div>
      <div v-if="isOpenList" class="dropdown-list">
        <vue-perfect-scrollbar class="list-scroll-area">
          <div
            v-for="option of options.data"
            :key="option.id"
            class="dropdown-item"
            @click="setIsCheckElement(option)"
          >
            {{ option.code_alfa }}
          </div>
        </vue-perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import WalletIcon from "../resources/js/icons/WalletIcon.vue";
import { ChevronDownIcon, KeyIcon } from "vue-feather-icons";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { onVibrate } from "../helpers/utils";

export default {
  name: "Tab-input",
  components: {
    WalletIcon,
    KeyIcon,
    ChevronDownIcon,
    VuePerfectScrollbar,
  },
  props: {
    title: {
      type: String,
      require: true,
    },
    placeholder: {
      type: String,
      require: true,
    },
    value: {
      type: String,
      require: true,
    },
    isPrice: {
      type: Boolean,
      require: false,
    },
    options: {
      type: Array,
      require: false,
    },
    listValue: {
      type: Object,
      require: false,
    },
    isCategoryName: {
      type: Boolean,
      require: false,
    },
    inputId: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      data: "",
      isOpenList: false,
      checkedValue: null,
    };
  },
  async mounted() {
    console.log(this.options, "options");
  },

  methods: {
    setIsOpenList() {
      onVibrate("click");
      this.isOpenList = !this.isOpenList;
    },
    filterInput(event) {
      if (this.isPrice) {
        let newValue = event.target.value;
        newValue = newValue.replace(/[^0-9.]/g, "");

        const dotCount = (newValue.match(/\./g) || []).length;
        if (dotCount > 1) {
          newValue = newValue.replace(/\.(?=.*\.)/g, "");
        }

        newValue = newValue.replace(/(\.[0-9]{2}).*/g, "$1");
        this.data = newValue;
      }
    },
    setIsCheckElement(val) {
      onVibrate("click");
      this.$emit("check-list-value", val);
      this.checkedValue = val.code_alfa;
      this.isOpenList = false;
    },
    handleEnterKey() {
      const activeElement = document.activeElement;
      if (activeElement.tagName === "INPUT") {
        activeElement.blur();
      }
    },
    onFocusElement() {
      onVibrate("click");
      this.$emit("is-open-keyboard", true);
    },
    onBlurElement() {
      this.$emit("is-open-keyboard", false);
    },
  },

  computed: {},
  watch: {
    value(newVal, oldVal) {
      this.data = newVal;
      let val = oldVal;
      val;
    },
    data(newVal, oldVal) {
      this.$emit("custom-input-val", newVal);
      let val = oldVal;
      val;
    },
    listValue(newVal, oldVal) {
      if (!newVal) {
        return;
      }
      console.log(123);
      this.checkedValue = newVal.code_alfa;
      let val = oldVal;
      val;
    },
  },
};
</script>

<style scoped>
.dropdown-main-container {
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  width: fit-content;
  position: relative;
  width: 100%;
  cursor: pointer;
}
.dropdown-main-container .text {
  font-size: 12px;
  color: #4a89dc;
  font-weight: 700;
  position: relative;
  top: 5px;
  margin: 0 0 0 7px;
  padding: 0 3px;
  line-height: 10px;
  background: #e8e8e8;
  width: fit-content;
}
.dropdown-main-container .text-input {
  padding: 11px 10px;
  font-size: 0.75rem;
  border: 1px rgba(0, 0, 0, 0.07) solid !important;
  border-radius: 10px;
  background: #e8e8e8;
  height: 53px;
  outline: none;
  padding-left: 40px;
  padding-right: 100px;
  font-weight: 400;
  line-height: 1.5;
  font-size: 12px;
  font-family: "Source Sans 3", sans-serif;
  color: #212529;
}
.dropdown-main-container .text-input::placeholder {
  color: #555f69;
}
.dropdown-left-icon-price {
  position: absolute;
  bottom: 40px;
  width: 23px;
  height: 23px;
  left: 10px;
}
.dropdown-left-icon {
  position: absolute;
  bottom: 15px;
  width: 23px;
  height: 23px;
  left: 10px;
}
.dropdown-left-icon-category {
  position: absolute;
  bottom: 15px;
  width: 20px;
  height: 20px;
  left: 10px;
}
.price-list-block {
  padding: 5px 15px;
  font-size: 0.75rem;
  border: 1px rgba(0, 0, 0, 0.07) solid;
  border-radius: 10px;
  background: #e8e8e8;
  height: 100%;
}
.dropdown-chevron-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 17px;
  height: 17px;
  margin-left: auto;
  transition: all 0.25s ease;
}
.dropdown-list {
  position: absolute;
  width: 100%;
  z-index: 100;
  top: 41px;
  height: 150px;
  background: #e8e8e8;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 10px;
  overflow: hidden;
}
.dropdown-checked-value {
  font-weight: 400;
  line-height: 35px;
  font-size: 12px;
  font-family: "Source Sans 3", sans-serif;
  color: #212529;
}
.dropdown-item {
  font-weight: 400;
  line-height: 1.5;
  font-size: 15px;
  background: transparent;
  font-family: "Source Sans 3", sans-serif;
  color: #212529;
  padding: 5px 10px;
  max-width: 50px;
  overflow: hidden;
  transition: all 0.25s ease;
}
.dropdown-item:hover {
  background-image: var(--main-bg-color);
  color: #fff;
  border-radius: 3px;
  padding-left: 14px;
}
.list-scroll-area {
  max-height: 135px;
  width: 100%;
}
.currency-container {
  position: absolute;
  top: 40px;
  right: 10px;
  height: 40px;
  width: 80px;
}
.dropdown-list-checked-value {
  font-weight: 400;
  line-height: 32px;
  font-size: 14px;
  font-family: "Source Sans 3", sans-serif;
  color: #212529;
}
</style>
